//@ts-ignore
import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import CreateIcon from "../../Icons/CreateIcon";
import { useState } from "react";

const EditStaffComponent = loadable(
  () => import("../../components/Staff/EditStaffInfo")
);

const EditStaffInfo = () => {
  const { id } = useParams();
  const [openUserFormPopup, setOpenUserFormPopup] = useState(false);

  const {
    data: staff,
    refetch,
    isLoading,
  } = useGetHook({
    queryKey: ["staff", `staff-${id}`],
    url: `${APIS.STAFF_INFO}${id}/`,
    params: {},
  });
  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["staffs"],
    navigateURL: "/human-resource-management/employee/staff",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.STAFF_INFO}${id}/`;
    const { user, ...rest } = values;
    const formData = {
      ...rest,
    };
    console.log(formData, "formdata");
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        refetch();
      }
    } catch (err) {
      toast.error(err);
    }
  };
  const { data: currentClient, isLoading: isCurrentClientLoading } = useGetHook(
    {
      queryKey: ["curent-client"],
      url: APIS.CLIENT,
      params: {},
    }
  );
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Staff ({staff?.full_name}){" "}
        </span>
      </div>
      {isLoading || isCurrentClientLoading ? (
        <Spinner />
      ) : (
        <EditStaffComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          profile={staff}
          refetch={refetch}
          currentClient={currentClient}
          setOpenUserFormPopup={setOpenUserFormPopup}
          openUserFormPopup={openUserFormPopup}
        />
      )}
    </>
  );
};
export default EditStaffInfo;
